<template>
    <div class="vue-garage-select" :class="{'error': hasError}">
        <v-select
            v-model="selectedGarage"
            @input="handleInput"
            @search="handleSearch"
            :options="garages"
            :filterable="false"
            placeholder="Zoek op postcode of plaats"
            label="name"
            :loading="loading"
        >
            <template slot="option" slot-scope="option">
                {{ option.name }} <span style="font-style: italic;">({{ option.distance | formatDistance }})</span>
            </template>

            <template #no-options="{ search, searching, loading }">
                Vul a.u.b. een geldige postcode of plaatsnaam in.
            </template>
        </v-select>
    </div>
</template>

<script>
import garageSelect from "../mixins/garage-select";

export default {
    name: "GarageSelect",

    mixins: [garageSelect],

    props: ['initialSelected', 'inputClasses'],

    computed: {
        hasError() {
            return this.inputClasses.includes('error');
        }
    },

    created() {
        this.fetchGarages()
            .finally(() => {
                if (_.isEmpty(this.initialSelected)) {
                    return;
                }

                this.selectedGarage = _.find(this.garages, (garage) => {
                    return garage.id === this.initialSelected
                });

                this.handleInput(this.selectedGarage);
            });
    },

    methods: {
        handleInput(payload) {
            let webformElement = document.querySelector('.carprof-garage-select-element input.webform-garage-select-element');
            let webformElementGarageName = document.querySelector('input[name="garage_name"]');

            this.loading = false;

            if (_.isEmpty(payload)) {
                webformElement.value = '';
                webformElementGarageName.value = '';
                return;
            }

            webformElement.value = payload.id;
            webformElementGarageName.value = payload.name;
        },
    }
}
</script>